export default __webpack_public_path__ + "static/media/57825512.0fd902d9.jpeg";